export default {
    key: "other_occupations",
    folder: "otherOccupations",
    basePath: "others",
};